import axios, { AxiosError } from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/resguardos';


const resguardosApi = {
    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },
    crear: async (data: any) => {
        try {
            const response = await axios.post(`${BASE_URL}/crear`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error creating resguardo:', error);
            return null;
        }
    },
    listadoId: async (id: string) => {
        try {
            const response = await axios.get(`${BASE_URL}/listado/hotels/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },
    agregarAResguardo: async (data: any) => {
        try {
            const response = await axios.post(`${BASE_URL}/agregar/nuevo`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },

    obtenerActivosPorResguardo: async (id: Number) => {
        try {
            const response = await axios.post(`${BASE_URL}/activos/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error fetching activos:', error);
            return [];
        }
    },

     quitarDeResguardo: async (resguardoId: any, activoId: any) => {
    try {
      const response = await fetch(`${BASE_URL}/${resguardoId}/activos/${activoId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error('Error al quitar el activo del resguardo');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  },

    eliminar: async (id: Number) => {
        try {
            const response = await axios.delete(`${BASE_URL}/eliminar/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error deleting resguardo:', error);
            return null;
        }
    },

    editar: async (id: Number, data: any) => {
        try {
            const response = await axios.put(`${BASE_URL}/editar/${id}`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return Array.isArray(response.data) ? response.data[0] : response.data;
        } catch (error) {
            console.error('Error editing resguardo:', error);
            return null;
        }
    },

    enviarSolicitudFirmaRemota: async (
        resguardoId: number,
        correo: string,
        copiaCorreos?: string[],
        mensajePersonalizado?: string
    ) => {
        const response = await axios.post(`${BASE_URL}/firma-remota/solicitar`, {
            resguardoId,
            correo,
            ...(copiaCorreos && copiaCorreos.length > 0 ? { copiaCorreos } : {}),
            ...(mensajePersonalizado && mensajePersonalizado.trim() ? { mensajePersonalizado } : {})
        });
        return response.data;
    },

    obtenerPorToken: async (token: string) => {
        const response = await axios.get(`${BASE_URL}/firma-remota/${token}`);
        return response.data;
    },

    confirmarFirmaRemota: async (token: string, firmaDigital: string) => {
        const response = await axios.post(`${BASE_URL}/firma-remota/${token}/confirmar`, {
            firmaDigital
        });
        return response.data;
    },

    obtenerHistorico: async (id: Number) => {
        try {
            const response = await axios.get(`${BASE_URL}/historico/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching historico de resguardo:', error);
            return null;
        }
    },

    obtenerHistoricoBatch: async (ids: Array<number>) => {
        try {
            const response = await axios.post(`${BASE_URL}/historico/batch`, { ids }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data?.historicos || [];
        } catch (error) {
            console.error('Error fetching historico batch de resguardos:', error);
            return [];
        }
    },

    verificarBajas: async (hotelId: number) => {
        try {
            const response = await axios.get(`${BASE_URL}/verificar-bajas/hoteles/${hotelId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching resguardos con colaboradores dados de baja:', error);
            return null;
        }
    }
}

export default resguardosApi;